"use client";

import type { BetterAuthClientOptions } from "better-auth/client";
import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";

type ReactAuthClient<Option extends BetterAuthClientOptions> = ReturnType<
  typeof createAuthClient<Option>
>;

const authClientOptions = {
  plugins: [oauthProviderClient(), magicLinkClient()],
} satisfies BetterAuthClientOptions;

export const authClient: ReactAuthClient<typeof authClientOptions> =
  createAuthClient(authClientOptions);

export const { signIn, signOut, useSession } = authClient;

// useUser hook that provides user information from the session
export function useUser() {
  const { data: session, isPending } = useSession();

  return {
    isLoaded: !isPending,
    isSignedIn: Boolean(session?.user),
    user: session?.user
      ? {
          id: session.user.id,
          firstName: session.user.name?.split(" ")[0] ?? null,
          lastName: session.user.name?.split(" ").slice(1).join(" ") ?? null,
          fullName: session.user.name ?? null,
          emailAddresses: session.user.email
            ? [{ emailAddress: session.user.email }]
            : [],
          primaryEmailAddress: session.user.email
            ? { emailAddress: session.user.email }
            : null,
          imageUrl: session.user.image ?? null,
        }
      : null,
  };
}
